import { BaseEdge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from '@xyflow/react';
import { Repeat, X } from 'lucide-react';
import { nodeColors } from '../../theme/colors';
import { useFlowStore } from '../../store/flowStore';

// Aresta de loopback: tracejada roxa, animada (fluindo) + rótulo "loop" + excluir ao selecionar.
export function LoopEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  label,
  markerEnd,
  selected,
}: EdgeProps) {
  const deleteEdge = useFlowStore((s) => s.deleteEdge);
  const [path, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    curvature: 0.5,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={path}
        markerEnd={markerEnd}
        style={{ stroke: nodeColors.loop, strokeWidth: selected ? 3 : 2 }}
      />
      <path d={path} fill="none" stroke={nodeColors.loop} strokeWidth={2} className="edge-flow" style={{ pointerEvents: 'none' }} />

      <EdgeLabelRenderer>
        <div
          style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)` }}
          className="pointer-events-none absolute flex items-center gap-1 rounded-full border border-node-loop/30 bg-white px-2 py-0.5 text-[10px] font-semibold text-node-loop shadow-sm"
        >
          <Repeat className="h-3 w-3" />
          {typeof label === 'string' ? label : 'loop'}
        </div>
        {selected && (
          <div
            style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY + 22}px)` }}
            className="edge-action nodrag nopan absolute"
          >
            <button
              onClick={() => deleteEdge(id)}
              className="flex h-6 w-6 items-center justify-center rounded-full border border-line bg-white text-slate shadow-soft transition-colors hover:border-danger hover:bg-danger hover:text-white"
              aria-label="Excluir conexão"
              title="Excluir conexão"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        )}
      </EdgeLabelRenderer>
    </>
  );
}
